module.exports = __webpack_public_path__ + "static/media/Locus.8f68bf99.png";